/*
  登录、菜单
*/
import request from "@/utils/request";

let baseUrl1 = window.config.baseUrl4WebTeacher  // 梁江辉接口地址1
let baseUrl2 = window.config.baseUrl4Shool  // 飞泉接口地址online

// 学校端 登录
export function login(data: Object) {
  return request({
    url: "/login/adminLogin",
    method: "post",
    data
  });
}

// 学校端 登出  /login/logout  退出登录
export function shoolLoginOut() {
  return request({
    url: `/login/logout`,
    method: "get"
  })
}

// 学校端 验证码  /teacher/code/image  获取验证码
export function getSchoolCode() {
  return request({
    url: `login/image`,
    method: "get"
  })
}

// 教师端端 验证码  /teacher/code/image  获取验证码
export function getTeacherCode() {
  return request({
    url: window.config.baseUrl4WebTeacher + `/teacher/tchLogin/image`,
    method: "get"
  })
}

// 重置密码
export function resetPwd(data) {
  if (data.type === "teacher") {
    return request({
      url: window.config.baseUrl4WebTeacher + '/teacher/signuUp/resetPasswords',
      method: 'post',
      data: data.value
    })
  } else {
    return request({
      url: window.config.baseUrl4Shool + '/baseinfo/teacherinfo/resetPasswords',
      method: 'post',
      data: data.value
    })
  }
}

// web教师端 登录 ---跑江辉的接口 /teacher/tchLogin/login
export function teacherLogin(data: Object) {
  return request({
    // url: baseUrl1+"/teacher/tchLogin/login",
    // url: window.config.baseUrl4TestTeacher+"/teacher/tchLogin/login",
    url: window.config.baseUrl4WebTeacher + "/teacher/tchLogin/login",
    method: "post",
    data
  });
}

// /teacher/tchLogin/logout 用户登出

// web教师端 退出登录
export function teacherLoginOut() {
  request({
    // url: baseUrl1+"/teacher/tchLogin/logout ",
    url: window.config.baseUrl4WebTeacher + "/teacher/tchLogin/logout ",
    method: "post"
  });
}

//统一身份认证 —— 获取access token的接口
export function getAccessToken(data: Object) {
  return request({
    url:
        window.config.loginBaseUrl + "/oauth/token?grant_type=authorization_code",
    method: "post",
    data
  });
}


// 查询当前用户所属权限   /baseResource/getCurrUserResources

export function getCurrUserResources() {
  return request({
    url: "/baseResource/getCurrUserResources",
    method: "get",
  });
}

// school端  /baseMenu/currUserMenuTreeList 获取当前用户菜单树
export function getCurrUserMenuTree() {
  return request({
    url: `/baseMenu/currUserMenuTreeList`,
    method: 'get',
  })
}

// teacher端  /teacherMenu/teacherUserMenuTreeList 获取当前用户菜单树
export function teacherUserMenuTreeList() {
  return request({
    // url:baseUrl1+`/teacherMenu/teacherUserMenuTreeList `,
    url: window.config.baseUrl4WebTeacher + `/teacherMenu/teacherUserMenuTreeList `,
    method: 'get',
  })
}


// 学校端 获取用户姓名
export function getUser() {
  return request({
    url: "/baseinfo/teacherinfo/getUser",
    method: "get"
  });
}

// 教师端 获取用户姓名
export function getTeacherUser() {
  return request({
    url: window.config.baseUrl4WebTeacher + "/teacher/signuUp/getUser",
    method: "get"
  });
}

// 教师端 获取用户姓名
export function getTeacherUserByMobile(params) {
  return request({
    url: window.config.baseUrl4WebTeacher + "/teacher/signuUp/getUserByMobile",
    method: "get",
    params
  });
}


// 发送短信验证码
export function getSMS(params) {
  return request({
    url: window.config.baseUrl4WebTeacher + "/sysmange/ssms/getVerificationCode",
    method: "get",
    params
  });
}

// 使用短信登录
export function loginBySms(data) {
  return request({
    url: window.config.baseUrl4WebTeacher +"/teacher/tchLogin/loginByVerificationCode",
    method: "post",
    data
  });
}
